import { useMemo, useState, type ReactNode } from 'react'
import { DonsModalContext } from './donsModalStore'

export function DonsModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false)

  const value = useMemo(
    () => ({ isOpen, open: () => setIsOpen(true), close: () => setIsOpen(false) }),
    [isOpen],
  )

  return <DonsModalContext.Provider value={value}>{children}</DonsModalContext.Provider>
}
